import { render, staticRenderFns } from "./UpdatePushApp.vue?vue&type=template&id=a05a7acc&scoped=true&"
import script from "./UpdatePushApp.vue?vue&type=script&lang=js&"
export * from "./UpdatePushApp.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePushApp.vue?vue&type=style&index=0&id=a05a7acc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a05a7acc",
  null
  
)

export default component.exports